
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("b89xc", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

/* TaskList.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $ffCOo = parcelRequire("ffCOo");


var $fRWmC = parcelRequire("fRWmC");


var $dh538 = parcelRequire("dh538");


var $8C5kA = parcelRequire("8C5kA");

const $453d2759ff34aabb$var$oldListStyles = null;
const $453d2759ff34aabb$var$listStyles = null;
const $453d2759ff34aabb$var$taskListStyles = null;
const $453d2759ff34aabb$var$TaskList = ({ listId: listId, children: children })=>{
    const listSize = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (!children) return null;
     // Data attributes are required for copy and paste from rendered content
    // to the editor to preserve the task.
    // This allows the editor to differentiate between numbered and ordered lists,
    // and action items, which all share the common '‹li›' element.
    // The value of 'data-task-local-id' should be discarded upon paste, with a
    // a new uuid generated by the editor for the cloned content.
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "group",
        "data-task-list-local-id": "",
        "aria-label": formatMessage((0, $fRWmC.messages).fieldsetLabel),
        className: (0, $gMc0m.default)([
            (0, $dh538.fg)('platform_editor_fix_missing_task_id') ? "_2mzuglyw _19bvidpf _j6mf1b66" : "_2mzuglyw _19bvidpf"
        ]),
        children: (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, (child, idx)=>{
            const { localId: localId } = child.props;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $ffCOo.FabricElementsAnalyticsContext), {
                data: {
                    listLocalId: listId,
                    listSize: listSize,
                    position: idx
                },
                children: /* The data-task-local-id attribute will be moved to the Editor renderer node
        as the localId isn't guaranteed to be in the direct React child's props) */ (0, $dh538.fg)('platform_editor_fix_missing_task_id') ? child : /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    "data-task-local-id": localId || '',
                    className: (0, $gMc0m.default)([
                        "_19pk1b66"
                    ]),
                    children: child
                }, idx)
            });
        })
    });
};
var $453d2759ff34aabb$export$2e2bcd8739ae039 = $453d2759ff34aabb$var$TaskList;


class $4a5b8b074e57175b$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    render() {
        const { children: children, localId: localId } = this.props;
        if ((0, $42omo.Children).count(children) === 0) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $453d2759ff34aabb$export$2e2bcd8739ae039), {
            listId: localId,
            children: children
        });
    }
}
module.exports["default"] = $4a5b8b074e57175b$export$2e2bcd8739ae039;

});

parcelRegister("fRWmC", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $01fdfd6ac0ede0b3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    fieldsetLabel: {
        id: "fabric.editor.fieldsetLabel",
        defaultMessage: "Action Item List"
    },
    markTaskAsCompleted: {
        id: "platform.taskDecision.markTaskAsCompleted",
        defaultMessage: "Mark task as completed"
    },
    markTaskAsNotCompleted: {
        id: "platform.taskDecision.markTaskAsNotCompleted",
        defaultMessage: "Mark task as not completed"
    },
    decisionAriaLabel: {
        id: "platform.taskDecision.decisionAriaLabel",
        defaultMessage: "Decision"
    },
    undefinedDecisionAriaLabel: {
        id: "platform.taskDecision.undefinedDecisionAriaLabel",
        defaultMessage: "Undefined decision"
    }
});
module.exports["messages"] = $01fdfd6ac0ede0b3$export$defe85febe8b728c;

});


//# sourceMappingURL=taskList.7a67f9c5.js.map
